
import { defineComponent} from 'vue'
import LayoutHeader from './Header.vue'
import LayoutSidebar from './Sidebar.vue'
import LayoutMain from './Main.vue'

export default defineComponent({
  name: 'LayoutIndex',
  components: {
    LayoutHeader, LayoutSidebar, LayoutMain
  },
  setup() {
    
    return {}
  },
})
